import { useState } from "react";
import api, { extractError } from "@/api/client";
import { Star, X, Check } from "lucide-react";

function Stars({ value, onChange, testId }) {
  return (
    <div className="flex gap-1" data-testid={testId}>
      {[1,2,3,4,5].map((n) => (
        <button key={n} type="button" onClick={() => onChange(n)}
          className="transition hover:scale-110"
          data-testid={`${testId}-${n}`}>
          <Star size={32} className={n <= value ? "fill-yellow-400 text-yellow-400" : "text-[var(--border)]"} />
        </button>
      ))}
    </div>
  );
}

export default function RatingModal({ order, onClose, onRated }) {
  const [driverStars, setDriverStars] = useState(0);
  const [foodStars, setFoodStars] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async () => {
    if (!driverStars && !foodStars) { setErr("يرجى تقييم السائق أو الطعام"); return; }
    setBusy(true); setErr("");
    try {
      await api.post(`/orders/${order.id}/rate`, {
        driver_stars: driverStars || null,
        food_stars: foodStars || null,
        comment,
      });
      onRated?.();
      onClose();
    } catch (e) { setErr(extractError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-sm flex items-end sm:items-center justify-center p-4" onClick={onClose} data-testid="rating-modal">
      <div onClick={(e) => e.stopPropagation()} className="bg-white w-full sm:max-w-md rounded-3xl shadow-2xl overflow-hidden animate-fade-up">
        <div className="flex justify-between items-center p-5 border-b border-[var(--border)]">
          <div>
            <h2 className="text-xl font-black" style={{fontFamily:'Cairo'}}>كيف كانت تجربتك؟</h2>
            <div className="text-xs text-[var(--text-secondary)] mt-0.5">طلب {order.code}</div>
          </div>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-[var(--surface-alt)] flex items-center justify-center"><X size={16}/></button>
        </div>
        <div className="p-5 flex flex-col gap-5">
          {order.driver && (
            <div>
              <div className="text-sm font-bold mb-2">قيّم السائق {order.driver.name}</div>
              <Stars value={driverStars} onChange={setDriverStars} testId="rate-driver"/>
            </div>
          )}
          <div>
            <div className="text-sm font-bold mb-2">قيّم الطعام</div>
            <Stars value={foodStars} onChange={setFoodStars} testId="rate-food"/>
          </div>
          <div>
            <label className="text-sm font-bold block mb-1">تعليق (اختياري)</label>
            <textarea rows={3} value={comment} onChange={(e) => setComment(e.target.value)}
              placeholder="أخبرنا بتجربتك..."
              className="w-full px-4 py-2.5 rounded-xl border border-[var(--border)] bg-[var(--surface-alt)] focus:bg-white focus:border-primary-brand focus:outline-none resize-none text-right"
              data-testid="rate-comment"/>
          </div>
          {err && <div className="bg-red-50 text-red-600 px-3 py-2 rounded-lg text-sm">{err}</div>}
          <button onClick={submit} disabled={busy}
            className="w-full py-3.5 rounded-xl bg-primary-brand text-white font-bold text-base talabya-shadow-float disabled:opacity-60 flex items-center justify-center gap-2"
            data-testid="rate-submit">
            <Check size={18}/> {busy ? "جاري الإرسال..." : "إرسال التقييم"}
          </button>
        </div>
      </div>
    </div>
  );
}
